<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['organizationId', 'account', 'organizationSiteGroups']),
  },

  methods: {
    getPermissions({ routine, routineDefinition, finding }) {
      return useCases.findings.getPermissions({
        currentAccount: this.account,
        routine,
        routineDefinition,
        finding,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },
    canEditFinding({ routine, routineDefinition, finding }) {
      return this.getPermissions({ routine, routineDefinition, finding }).edit
    },
    canDeleteFinding({ routine, routineDefinition, finding }) {
      return this.getPermissions({ routine, routineDefinition, finding }).delete
    },
    canAddressFinding({ routine, routineDefinition, finding }) {
      return this.getPermissions({ routine, routineDefinition, finding }).address
    },
    canCreateFinding({ routine, routineDefinition }) {
      return this.getPermissions({ routine, routineDefinition }).create
    },
  },
}
</script>
